import axios from 'axios'
import { CONFIG } from "../constants/config";

// Создаем экземпляр axios с базовой конфигурацией
const api = axios.create({
  baseURL: CONFIG.CLIENT_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json', 
    'X-Request-ID': CONFIG.X_ID,
  },
  responseType: 'json',
  withCredentials: true,
})

// Интерцептор для запросов
api.interceptors.request.use(
  (config) => {
    // Можно добавить токены авторизации или другие заголовки
    console.log('Отправка запроса:', config.url)
    return config
  },
  (error) => {
    console.error('Ошибка запроса:', error)
    return Promise.reject(error)
  }
)

// Интерцептор для ответов
api.interceptors.response.use(
  (response) => {
    console.log('Получен ответ:', response.status)
    return response
  },
  (error) => {
    console.error('Ошибка ответа:', error.response?.status, error.response?.data)
    
    // Обработка различных ошибок
    if (error.response?.status === 404) {
      console.error('Ресурс не найден')
    } else if (error.response?.status === 500) {
      console.error('Ошибка сервера')
    } else if (error.code === 'ECONNABORTED') {
      console.error('Превышено время ожидания запроса')
    }
    
    return Promise.reject(error)
  }
)

export default api 